module.exports = __webpack_public_path__ + "static/media/energy_availability_comparative_per_day.26a0493b.svg";